// import logo from './logo.svg';
import "./App.css";
import Genre from "./Components/Genre";
import Header from "./Components/Header";
import Videos from "./Components/Videos";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import VideoPlayer from "./Components/VideoPlayer";

function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Route path="/video-player/:videoId" component={VideoPlayer} />
          <Route path="/" component={Videos} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
